export function checkForMinimalCases(actions, formattedActions, problems){
 // now we analyze all that we've found in the log to see whether
    // all the actions were done for each problem and reset
    // the status if not all are there but should be counted
    // as minimal for the feedback.
    let pActions = []; //here we will store the actual problem actions that student did
    let pNames = []; //here we will store the problem names for the above with same order
    let pIndex = 0;
    let pActIndex = -1;

    

    actions.forEach((action, j) => {
        if (action.type === "intervention") {
            //good interventions can have these status values
            if (!!action.status && action.status.includes("goodIntv", "incorrect-answers", "minimal", "misOrdered-goodIntv",
            "misOrdered-incorrect-answers", "minimal", "misOrdered-minimal",
            "misOrdered-minimal-incorrect-answers",
            "misOrdered-phase-incorrect-answers", "misOrdered-phase-minimal-incorrect-answers", "misOrdered-phase-minimal")) {
                if (!pNames.includes(action.probLabel)) {
                    pActIndex = pIndex;
                    pNames[pActIndex] = action.probLabel;
                    pIndex++;}
                else { pActIndex = pNames.indexOf(action.probLabel); }
                let actions = pActions[pActIndex];
                if (!actions) { actions = []; }
                actions.push(action);
                pActions[pActIndex] = actions;
            }
        }
    });

    // If all the minimal were found but not all the action were, then we
    // need to re-mark the action objects created for the minimal events
    // to be minimal instead of goodIntv.  It isn't
    // appropriate to give this feedback if all actions are present.
    // Waited until now so that all the events are in one list instead of
    // a list per phase,
    let processedIds = formattedActions.map(event => event.id);
    let pIds = problems.map(a => a.probLabel);
    pNames.forEach((pEntry, j) => {
        //get the action definition for this problem
        let pIndex = pIds.indexOf(pEntry);
        let prob = problems[pIndex];
        let actionNeeded = prob.allActions.filter(obj => obj.protocolRelationship === "required").map(obj => obj.id);
        //collect statuses for these actions

        let minimalNeeded = prob.allActions.filter(obj => obj.protocolRelationship === "minimal").map(obj => obj.id);
        if (minimalNeeded) { //no point in doing anything else if no minimals were defined
            let foundActions = pActions[j];
            let found = foundActions.map(a => a.id);
            let allActionFound = true;
            let allMinimalFound = true;
            for (let item of actionNeeded) {
                if (!found.includes(item)) {
                    allActionFound = false;
                    break;
                }
            }
            for (let item of minimalNeeded) {
                if (!found.includes(item)) {
                    allMinimalFound = false;
                    break;
                }
            }
            let numericalIDsChanged = [];
            if (!allActionFound && allMinimalFound) {
                minimalNeeded.forEach((foundId, j) => {
                    let pIndex = processedIds.indexOf(foundId);
                    let object = formattedActions[pIndex];

                    //find object to modify
                    object.minimalWhy = prob.minimalWhy;
                    switch (object.status){
                        case "incorrect-answers":
                            object.status = "minimal-incorrect-answers"
                            break
                        case "goodIntv":
                            object.status = "minimal"
                            break
                        case "misOrdered-goodIntv":
                            object.status = "misOrdered-minimal"
                            break
                        case "misOrdered-incorrect-answers":
                            object.status = "misOrdered-minimal-incorrect-answers"
                            break
                        case "misOrdered-phase-goodIntv":
                            object.status = "misOrdered-phase-minimal"
                            break
                        case "misOrdered-phase-incorrect-answers":
                            object.status = "misOrdered-phase-minimal-incorrect-answers"
                            break
                        default:
                            break}

                    numericalIDsChanged.push(object.numericalID);
                    formattedActions[pIndex] = object;
                });
                //redo color for header if needed
                let header = {};
                numericalIDsChanged.forEach((numericalID, z) => {
                    header = findHeaderFor(numericalID, formattedActions);
                    if (header && header.displayColor === "green") { header.displayColor = "yellow"; }
                });

            }
        }
        prob.actions = []  //clear out this working field from problems definitions

    });
      
}
